import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "calc(100vh - 80px)",
    padding: theme.spacing(2)
  },
  sidebar: {
    width: 280,
    marginRight: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  },
  sidebarHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  sessionList: {
    flex: 1,
    overflow: "auto"
  },
  sessionItem: {
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover
    }
  },
  sessionItemActive: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    transition: "all 0.2s"
  },
  chatArea: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  chatHeader: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1)
  },
  messagesContainer: {
    flex: 1,
    overflow: "auto",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    textAlign: "center",
    padding: theme.spacing(4)
  },
  messageBubble: {
    maxWidth: "80%",
    [theme.breakpoints.up("md")]: {
      maxWidth: "75%"
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "65%"
    },
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    marginBottom: theme.spacing(1.5)
  },
  userMessage: {
    marginLeft: "auto",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    whiteSpace: "pre-wrap"
  },
  assistantMessage: {
    marginRight: "auto",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    "& *": {
      whiteSpace: "normal"
    }
  },
  inputArea: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: "flex",
    gap: theme.spacing(0.5),
    backgroundColor: theme.palette.background.paper,
    "&:focus-within": {
      boxShadow: "0 0 0 3px rgba(230, 0, 126, 0.1)"
    }
  },
  inputField: {
    flex: 1
  },
  footer: {
    padding: theme.spacing(1, 2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.divider}`,
    fontSize: 12,
    color: theme.palette.text.secondary
  },
  feedbackButton: {
    color: theme.palette.primary.main,
    marginLeft: "auto",
    textTransform: "none",
    fontFamily: '"Satoshi", sans-serif',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: "20px"
  },
  feedbackActive: {
    color: theme.palette.primary.main
  },
  feedbackThumbRow: {
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  partnerChip: {
    marginLeft: "auto"
  },
  statusIndicator: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(1)
  },
  markdownContent: {
    "& p": {
      margin: 0,
      marginBottom: theme.spacing(1),
      "&:last-child": {
        marginBottom: 0
      }
    },
    "& pre": {
      backgroundColor: theme.palette.grey[100],
      padding: theme.spacing(1.5),
      borderRadius: 4,
      overflow: "auto",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      whiteSpace: "pre"
    },
    "& code": {
      backgroundColor: theme.palette.grey[100],
      padding: "2px 6px",
      borderRadius: 3,
      fontSize: "0.9em",
      fontFamily: "monospace"
    },
    "& pre code": {
      backgroundColor: "transparent",
      padding: 0
    },
    "& table": {
      borderCollapse: "collapse",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: "100%",
      display: "block",
      overflowX: "auto"
    },
    "& thead": {
      backgroundColor: theme.palette.action.hover
    },
    "& th, & td": {
      border: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(0.5, 1),
      textAlign: "left",
      fontSize: 12
    },
    "& th": {
      fontWeight: 600
    },
    "& h1, & h2, & h3": {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(0.75),
      fontWeight: 600
    },
    "& ul, & ol": {
      paddingLeft: theme.spacing(3),
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5)
    },
    "& li": {
      marginBottom: theme.spacing(0.25)
    },
    "& blockquote": {
      borderLeft: `3px solid ${theme.palette.divider}`,
      margin: 0,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1.5),
      color: theme.palette.text.secondary
    }
  }
}));

export default useStyles;
